import { render, staticRenderFns } from "./Encounter_tpSavings.vue?vue&type=template&id=d805b0fc&scoped=true&lang=html"
import script from "./Encounter_tpSavings.vue?vue&type=script&lang=js"
export * from "./Encounter_tpSavings.vue?vue&type=script&lang=js"
import style0 from "./Encounter_tpSavings.vue?vue&type=style&index=0&id=d805b0fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d805b0fc",
  null
  
)

export default component.exports